// import { withStyles } from "@material-ui/styles";
import {Checkbox} from '@mui/material/';
// import { withStyles } from "@mui/styles";
import { withStyles } from '@material-ui/core/styles';

const StyledInputCheck = withStyles((theme) => ({
}))(Checkbox);
export { StyledInputCheck };
